module.exports = __webpack_public_path__ + "static/media/diamond-card.708bf2fe.png";